<template>
  <MetaButton data-testid="item-views" tooltip="Analytics" tooltip-placement="top-start" @click.prevent="selectTab(SubheaderTabs.ANALYTICS, true)">
    <Icon name="general.eye" size="sm" />
    <span>{{ visitsMessage }}</span>
  </MetaButton>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { Icon } from '@/storybook/icon';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { storeToRefs } from 'pinia';
import { useSubheaderTabs, SubheaderTabs } from '../../composables/useSubheaderTabs';

const { publicVisitsCount } = storeToRefs(useViewerItemStore());
const { selectTab } = useSubheaderTabs();

const visitsMessage = computed(() => {
  return publicVisitsCount.value === 1 ? `1 view` : `${publicVisitsCount.value} views`;
});
</script>
